import React, {useRef} from 'react';
import {View, Platform} from 'react-native';
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from 'react-native-popup-menu';
import {useNavigation} from '@react-navigation/native';

import CachedImage from '../../elements/CachedImage';
import Text from '../../elements/Text';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import CommonStyles from '../../../utils/CommonStyles';
import Divider from '../../elements/Divider';
import WebPopupMenu from '../../elements/WebPopupMenu';
import {tID} from '../../../utils/TestIdHelper';
import {Logo, VerticalDotsIcon} from '../../../utils/SvgIcons';

const ProductCard = ({
  imageStyle = {},
  style,
  showMenu = false,
  product,
  onDelete,
  setProductBeingViewed,
}) => {
  // Called unconditionally (rules-of-hooks). On web the bundler aliases
  // '@react-navigation/native' to a no-op stub, and navigation is only used
  // in the native <Menu> branch below.
  const navigation = useNavigation();
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);

  const isFree = !(product.price > 0);
  const networkImage =
    product.images && product.images.length > 0 && product.images[0].imageUrl;
  const webPopupRef = useRef();

  return (
    <View
      testID={tID('ProductCard-View-Container')}
      style={style ? style : styles.container}>
      {networkImage ? (
        <CachedImage
          testID={tID('ProductCard-CachedImage-Product')}
          source={networkImage}
          style={{...styles.productImage, ...imageStyle}}
        />
      ) : (
        <Logo
          testID={tID('ProductCard-Image-Logo')}
          width={imageStyle?.width || 100}
          height={imageStyle?.height || 100}
          style={imageStyle}
        />
      )}
      <View style={styles.titleContainer}>
        <Text
          testID={tID('ProductCard-Text-Title')}
          numberOfLines={2}
          variation="Subtitle1SemiBold"
          color={colors.textMuted}>
          {product.title}
        </Text>
        {isFree ? (
          <View style={styles.priceContainer}>
            {/* promoText: brand purple in light, primary-text white in dark
                (purple was unreadable on dark surfaces — RC device pass). */}
            <Text
              testID={tID('ProductCard-Text-Free')}
              variation="Text1SemiBold"
              color={colors.promoText}>
              Free For Me
            </Text>
          </View>
        ) : (
          <View style={styles.freeContainer}>
            <Text
              testID={tID('ProductCard-Text-Price')}
              variation="Text1SemiBold"
              color={colors.textPrimary}>
              $ {parseFloat(product.price).toFixed(2)}
            </Text>
          </View>
        )}
      </View>
      {showMenu ? (
        Platform.OS === 'web' ? (
          <WebPopupMenu ref={webPopupRef} position="left center">
            <View>
              <Text
                testID={tID('ProductCard-Text-Product')}
                variation="Subtitle1Regular"
                color={colors.textMuted}
                style={CommonStyles.p_16}
                onPress={() => {
                  webPopupRef.current.close();
                  setProductBeingViewed(product);
                }}>
                Product Page
              </Text>
              <Divider color={colors.border} top={0} />
              <Text
                testID={tID('ProductCard-Text-Delete')}
                variation="Subtitle1Regular"
                color={colors.textMuted}
                style={CommonStyles.p_16}
                onPress={() => {
                  webPopupRef.current.close();
                  onDelete();
                }}>
                Delete Item
              </Text>
            </View>
          </WebPopupMenu>
        ) : (
          <Menu>
            <MenuTrigger>
              <View style={styles.p10}>
                <VerticalDotsIcon />
              </View>
            </MenuTrigger>
            <MenuOptions optionsContainerStyle={styles.optionContainer}>
              <MenuOption
                onSelect={() => navigation?.navigate('ViewProduct', {product})}
                customStyles={{optionWrapper: styles.optionWrapper}}>
                <Text
                  testID={tID('ProductCard-Text-Product')}
                  variation="Subtitle1Regular"
                  color={colors.textMuted}>
                  Product Page
                </Text>
              </MenuOption>
              <MenuOption
                onSelect={onDelete}
                customStyles={{optionWrapper: styles.paddingVertical16}}>
                <Text
                  testID={tID('ProductCard-Text-Delete')}
                  variation="Subtitle1Regular"
                  color={colors.textMuted}>
                  Delete Item
                </Text>
              </MenuOption>
            </MenuOptions>
          </Menu>
        )
      ) : null}
    </View>
  );
};

export default ProductCard;
